import React from "react";
import { Link } from "react-router-dom";
import "../../landing.css";
import localeText from "../../../../locale";

const cards = [
  {
    eyebrow: "lp2Card1Eyebrow",
    title: "lp2Card1Title",
    description: "lp2Card1Desc",
    cta: "lp2Card1Cta",
    icon: "pi pi-shopping-cart",
    to: "/customer",
  },
  {
    eyebrow: "lp2Card2Eyebrow",
    title: "lp2Card2Title",
    description: "lp2Card2Desc",
    cta: "lp2Card2Cta",
    icon: "pi pi-euro",
    to: "#negocio",
  },
  {
    eyebrow: "lp2Card3Eyebrow",
    title: "lp2Card3Title",
    description: "lp2Card3Desc",
    cta: "lp2Card3Cta",
    icon: "pi pi-sitemap",
    to: "/promoter",
  },
  {
    eyebrow: "lp2Card4Eyebrow",
    title: "lp2Card4Title",
    description: "lp2Card4Desc",
    cta: "lp2Card4Cta",
    icon: "pi pi-building",
    to: "/empresas",
  },
];

const highlightCard = {
  eyebrow: "lp2HighlightEyebrow",
  title: "lp2HighlightTitle",
  description: "lp2HighlightDesc",
  cta: "lp2HighlightCta",
  icon: "pi pi-clone",
  to: "/white-label",
};

const CardInner = ({ icon, eyebrow, title, description, cta, dark }) => (
  <>
    <div
      className="flex align-items-center justify-content-center border-round-lg"
      style={{
        width: "48px",
        height: "48px",
        backgroundColor: dark ? "rgba(255,255,255,0.1)" : "rgba(62,139,92,0.1)",
        color: dark ? "#fff" : "var(--extra-green)",
      }}
    >
      <i className={icon} style={{ fontSize: "1.3rem" }}></i>
    </div>
    <div
      className="eyebrow-text mt-4"
      style={{ color: dark ? "var(--extra-mint)" : "var(--extra-green)" }}
    >
      {localeText(eyebrow)}
    </div>
    <div
      className="font-bold text-2xl title mt-2"
      style={{ color: dark ? "#fff" : "var(--extra-green)" }}
    >
      {localeText(title)}
    </div>
    <div
      className="text-sm mt-2"
      style={{ color: dark ? "rgba(255,255,255,0.75)" : "var(--extra-body)" }}
    >
      {localeText(description)}
    </div>
    <div
      className="text-sm font-bold"
      style={{ color: dark ? "var(--extra-mint)" : "var(--extra-green)", marginTop: "auto", paddingTop: "1rem" }}
    >
      {localeText(cta)} <i className="pi pi-arrow-right text-xs card-cta-arrow"></i>
    </div>
  </>
);

const LandingChoosePath = () => {
  return (
    <section className="full-width py-8" style={{ backgroundColor: "var(--extra-soft)" }}>
      <div className="grid align-items-end">
        <div className="col-12 lg:col-7">
          <div className="eyebrow-text">{localeText("lp2ChoosePathEyebrow")}</div>
          <div
            className="font-bold text-4xl md:text-5xl title mt-2"
            style={{ color: "var(--extra-green)" }}
          >
            {localeText("lp2ChoosePathTitle")}
          </div>
        </div>
        <div className="col-12 lg:col-5">
          <div className="text-lg" style={{ color: "var(--extra-body)" }}>
            {localeText("lp2ChoosePathDescription")}
          </div>
        </div>
      </div>

      <div className="grid mt-4 py-3">
        {cards.map((card) => (
          <div key={card.title} className="col-12 sm:col-6 xl:col">
            {card.to.startsWith("/") ? (
              <Link
                to={card.to}
                className="landing-card-hover h-full flex flex-column p-4 border-round-lg no-underline"
                style={{ backgroundColor: "#fff" }}
              >
                <CardInner {...card} />
              </Link>
            ) : (
              <a
                href={card.to}
                className="landing-card-hover h-full flex flex-column p-4 border-round-lg no-underline"
                style={{ backgroundColor: "#fff" }}
              >
                <CardInner {...card} />
              </a>
            )}
          </div>
        ))}
        <div className="col-12 sm:col-6 xl:col">
          <Link
            to={highlightCard.to}
            className="landing-card-hover h-full flex flex-column p-4 border-round-lg no-underline"
            style={{ backgroundColor: "var(--extra-green-dark)" }}
          >
            <CardInner {...highlightCard} dark />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LandingChoosePath;
